.heading {
  color: var(--color-black);
  margin: 0;
  padding: 0;
  font-weight: normal;
  line-height: 1.3;

  h1& {
    font-family: var(--font-main);
    font-size: 3.2rem;
    font-weight: 500;
  }

  h2& {
    font-family: var(--font-main);
    font-size: 2.8rem;
    line-height: 1.2;
    font-weight: 500;
  }

  h3& {
    font-family: var(--font-main);
    font-size: 2.4rem;
    font-weight: 500;
  }

  h4& {
    font-family: var(--font-main);
    font-size: 2rem;
  }

  h5& {
    font-family: var(--font-main);
    font-size: 1.8rem;
  }

  h6& {
    font-family: var(--font-main);
    font-size: 1.8rem;
    font-weight: 500;
  }
}

.headingBright {
  color: var(--color-white);
}

.headingUppercase {
  text-transform: uppercase;
}

.headingBold {
  font-weight: 700;
}
